module.exports = __webpack_public_path__ + "HelveticaBoldOblique.eb4e50856e10b0769a3c.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-netsul/src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.svg
// module chunks = styles